var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"slideshow"}},[_c('div',{staticClass:"background"},[_c('div',{attrs:{"id":"info-wrap"}},[_c('div',{attrs:{"id":"info"}},[_c('div',{staticClass:"vakantieInfo"},[_c('h1',[_vm._v("Zomervakantie 2026")]),_c('h2',[_vm._v("1 - 17 juli")]),_c('h2',[_vm._v("17 - 28 augustus")])])])])])])
}]

export { render, staticRenderFns }